<p>2015-present</p>
<p>An ongoing meditation on home, change, and little pieces of evidence that things are not what they once were</p>
<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>

